import { useEffect } from 'react';

/** Client-side navigations keep the previous scroll position; reset it so every new route starts at the top. */
export const useScrollToTop = (pathname: string) => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);
};
